import { TokenTypes, PersonTypes } from 'state/types/UserTypes';
import { GlamboxCookieStore } from 'core/glambox/GlamboxCookieStore';
import { InitialState } from 'state/InitialState';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { UiActions } from 'state/actions/UiActions';
import { PersonActions } from 'state/actions/user/PersonActions';
import { NotifsActions } from 'state/actions/user/NotifsActions';
import { RewardsActions } from 'state/actions/user/RewardsActions';
import { BeautyProfileActions } from 'state/actions/user/BeautyProfileActions';
import { EditionsActions } from 'state/actions/user/EditionActions';
import { SubscribersActions } from 'state/actions/user/SubscribersActions';
import { PartnerInfoActions } from 'state/actions/user/PartnerInfoActions';
import { PartnerGeneralActions } from 'state/actions/user/PartnerGeneralActions';
import { PartnerSalesActions } from 'state/actions/user/PartnerSalesActions';
import { GlamboxLocalStore } from 'core/glambox/GlamboxLocalStore';

/**
 * Just a cookie handler.
 *
 * @type {GlamboxCookieStore}
 */
const cookieHandle = new GlamboxCookieStore(
  '/',
  process.env.REACT_APP_GB_COOKIE_ROOT,
  false,
  new Date(Date.now() + 60 * 60 * 3 * 1000)
);

/**
 * Gerenciador de localStorage.
 */
const storageHandle = new GlamboxLocalStore();

// ----------------------------------------------------------------------

/**
 * Contém todas as actions necessárias para gerenciar o token de usuário.
 *
 * @type {Object}
 * @since 0.0.1
 */
export const TokenActions = {};

// THUNKS
// ----------------------------------------------------------------------

TokenActions.cookieMagic = (email, callback) => {
  return (dispatch, getState) => {
    dispatch(UiActions.loaderShow());

    dispatch(TokenActions.start());

    let queueId = 'UserToken-' + Date.now();
    dispatch(UiActions.queue(queueId));

    let bulkLoadId = 'BulkLoadData-' + Date.now();
    dispatch(UiActions.queue(bulkLoadId));

    let state = getState();

    if (
      state.person.data.person.username !== 'tecnologia@b4agroup.com' &&
      state.person.data.person.username !== 'suporte@weclever.co'
    ) {
      dispatch(UiActions.publishErrorAlert('Ops! Parece que você não pode acessar isso aqui!'));
    }

    let response = ExecuteRequest(
      GlamboxEndpoints.Token.generate,
      {
        email,
      },
      'GET',
      {
        Authorization: state.token.data.Authorization,
      },
      null,
      (response) => {
        const { result, statusCode } = response;

        dispatch(UiActions.loaderHide());

        dispatch(TokenActions.pending(false));

        if (statusCode === 200) {
          dispatch(TokenActions.success(true));

          dispatch(TokenActions.set(result));

          storageHandle.set('GlamboxCurrentUser', result);

          console.log('antes do sync');
          dispatch(TokenActions.sync());

          let { Authorization, personId } = result;

          if (Authorization !== undefined) {
            cookieHandle.set('gbAuthorization', Authorization);
          }

          if (personId !== undefined) {
            cookieHandle.set('gbPersonId', personId);
          }

          dispatch(TokenActions.loadBulkData(email, bulkLoadId));
          // this.forceUpdate();
          if (callback && typeof callback === 'function') callback();
        } else {
          dispatch(UiActions.dequeue(bulkLoadId));
          dispatch(
            UiActions.publishErrorAlert(
              'Não foi possível realizar o login, por favor verifique o e-mail fornecido.'
            )
          );
        }

        dispatch(UiActions.dequeue(queueId));
      }
    );
  };
};

TokenActions.login = (email, password, isRegistration = false) => {
  return (dispatch) => {
    dispatch(UiActions.loaderShow());

    dispatch(TokenActions.start());

    let queueId = 'UserToken-' + Date.now();
    dispatch(UiActions.queue(queueId));

    let bulkLoadId = 'BulkLoadData-' + Date.now();
    dispatch(UiActions.queue(bulkLoadId));

    ExecuteRequest(
      GlamboxEndpoints.Open.login,
      {
        username: email,
        password,
      },
      'POST',
      null,
      null,
      (response) => {
        const { result, statusCode } = response;

        dispatch(UiActions.loaderHide());

        dispatch(TokenActions.pending(false));

        if (statusCode === 200) {
          // if (clearInfos === true) dispatch(TokenActions.logout());

          if (isRegistration === false) {
            storageHandle.set('userJustRegistered', false);
            storageHandle.set('userCheckFlag', true);
          }

          if (isRegistration === true) {
            storageHandle.set('userJustRegistered', true);
            storageHandle.set('userCheckFlag', true);
          }

          dispatch(TokenActions.success(true));

          dispatch(TokenActions.set(result));

          storageHandle.set('GlamboxCurrentUser', result);

          let { Authorization, personId } = result;

          if (Authorization !== undefined) {
            cookieHandle.set('gbAuthorization', Authorization);
          }

          if (personId !== undefined) {
            cookieHandle.set('gbPersonId', personId);
          }

          // if (document && window && window.location && !data.hasOwnProperty("access_token")) {
          //   let referrer = document.referrer,
          //       hostname = window.location.hostname,
          //       hnamergx = new RegExp(referrer, "gi");

          //   if (hnamergx.test(hostname) === false) {
          //     window.location = document.referrer;
          //   }
          // }

          dispatch(TokenActions.loadBulkData(email, bulkLoadId));
        } else {
          dispatch(UiActions.dequeue(bulkLoadId));
          dispatch(
            UiActions.publishErrorAlert(
              result && result.message
                ? result.message
                : 'Não foi possível realizar o login, por favor verifique o e-mail e senha digitados.'
            )
          );
        }

        dispatch(UiActions.dequeue(queueId));
      }
    );
  };
};

// TODO
TokenActions.loginWithToken = (access_token) => {
  return (dispatch) => {
    dispatch(
      TokenActions.fetch(
        GlamboxEndpoints.open.Identify,
        {
          access_token,
        },
        false,
        true
      )
    );
  };
};

TokenActions.identifyTokenAndPersonId = (token, personId, isRegistration = false) => {
  return (dispatch) => {
    dispatch(UiActions.loaderShow());

    dispatch(TokenActions.start());

    let queueId = 'UserToken-' + Date.now();
    dispatch(UiActions.queue(queueId));

    let bulkLoadId = 'BulkLoadData-' + Date.now();
    dispatch(UiActions.queue(bulkLoadId));

    cookieHandle.remove('gbRegisterInstagram');

    ExecuteRequest(
      GlamboxEndpoints.Person.identify,
      null,
      'GET',
      {
        Authorization: token,
      },
      null,
      (response) => {
        const { result, statusCode } = response;

        dispatch(UiActions.loaderHide());

        dispatch(TokenActions.pending(false));

        if (statusCode === 200) {
          // if (clearInfos === true) dispatch(TokenActions.logout());

          if (isRegistration === false) {
            storageHandle.set('userJustRegistered', false);
            storageHandle.set('userCheckFlag', true);
          }

          if (isRegistration === true) {
            storageHandle.set('userJustRegistered', true);
            storageHandle.set('userCheckFlag', true);
          }

          dispatch(TokenActions.success(true));

          dispatch(
            TokenActions.set({
              Authorization: token,
              personId: personId,
            })
          );

          storageHandle.set('GlamboxCurrentUser', {
            Authorization: token,
            personId: personId,
          });

          if (token !== undefined) {
            cookieHandle.set('gbAuthorization', token);
          }

          if (personId !== undefined) {
            cookieHandle.set('gbPersonId', personId);
          }

          dispatch(TokenActions.personDataLoadTemp(bulkLoadId));

          // dispatch(
          //   TokenActions.loadBulkData(
          //     email,
          //     bulkLoadId
          //   )
          // );
        } else {
          dispatch(UiActions.dequeue(bulkLoadId));
          dispatch(
            UiActions.publishErrorAlert(
              result && result.message
                ? result.message
                : 'Não foi possível realizar o login, por favor verifique o e-mail e senha digitados.'
            )
          );
        }

        dispatch(UiActions.dequeue(queueId));
      }
    );
  };
};

TokenActions.personDataLoadTemp = (bulkLoadId) => {
  return (dispatch, getState) => {
    let state = getState();

    ExecuteRequest(
      GlamboxEndpoints.Person.info,
      {},
      'GET',
      {
        Authorization: state.token.data.Authorization,
      },
      null,
      // {
      //   id: state.token.data.personId
      // }
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          dispatch(TokenActions.loadBulkData(result.username, bulkLoadId));
        } else {
          dispatch(TokenActions.logout());
        }

        dispatch(UiActions.dequeue(bulkLoadId));
      }
    );
  };
};

// TODO
TokenActions.loginWithFacebook = () => {
  // TODO: LoginWithFacebook
  return (dispatch) => {
    dispatch(UiActions.loaderShow());

    dispatch(TokenActions.start());

    let queueId = 'UserToken-' + Date.now();
    dispatch(UiActions.queue(queueId));

    let bulkLoadId = 'BulkLoadData-' + Date.now();
    dispatch(UiActions.queue(bulkLoadId));

    try {
      window.FB.login(
        (rr) => {
          if (rr.authResponse) {
            let requestData = {
              token_type: 'Bearer',
              expires_in: rr.authResponse.expiresIn,
              access_token: rr.authResponse.accessToken,
            };

            ExecuteRequest(
              GlamboxEndpoints.Open.loginWithFacebook,
              requestData,
              'POST',
              null,
              null,
              (response) => {
                const { result, statusCode } = response;

                dispatch(UiActions.loaderHide());

                dispatch(TokenActions.pending(false));

                if (statusCode === 200) {
                  // if (clearInfos === true) dispatch(TokenActions.logout());
                  storageHandle.set('userJustRegistered', false);
                  storageHandle.set('userCheckFlag', true);
                  storageHandle.set('loggedWithFacebook', true);
                  dispatch(TokenActions.success(true));

                  dispatch(TokenActions.set(result));

                  storageHandle.set('GlamboxCurrentUser', result);

                  let { Authorization, personId } = result;

                  if (Authorization !== undefined) {
                    cookieHandle.set('gbAuthorization', Authorization);
                  }

                  if (personId !== undefined) {
                    cookieHandle.set('gbPersonId', personId);
                  }

                  // if (document && window && window.location && !data.hasOwnProperty("access_token")) {
                  //   let referrer = document.referrer,
                  //       hostname = window.location.hostname,
                  //       hnamergx = new RegExp(referrer, "gi");

                  //   if (hnamergx.test(hostname) === false) {
                  //     window.location = document.referrer;
                  //   }
                  // }

                  // dispatch(
                  //   TokenActions.loadBulkData(
                  //     email,
                  //     bulkLoadId
                  //   )
                  // );

                  dispatch(TokenActions.personDataLoadTemp(bulkLoadId));
                } else {
                  dispatch(UiActions.dequeue(bulkLoadId));
                  dispatch(
                    UiActions.publishErrorAlert(
                      result && result.message
                        ? result.message
                        : 'Não foi possível realizar o login, por favor verifique suas credenciais do Facebook.'
                    )
                  );
                }

                dispatch(UiActions.dequeue(queueId));
              }
            );

            // dispatch(
            //   TokenActions.fetch(
            //     GlamboxEndpoints.open.LogInWithFacebook,
            //     requestData,
            //     false,
            //     true
            //   )
            // );
          } else {
            dispatch(UiActions.loaderHide());
            dispatch(UiActions.dequeue(bulkLoadId));
            dispatch(UiActions.dequeue(queueId));
          }
        },
        {
          // scope: 'public_profile,email,pages_show_list,instagram_basic,instagram_manage_insights',
          scope: 'public_profile,email',
        }
      );
    } catch (e) {
      dispatch(UiActions.loaderHide());
      dispatch(UiActions.loaderHide());
      dispatch(UiActions.dequeue(bulkLoadId));
      dispatch(UiActions.dequeue(queueId));
    }
  };
};

TokenActions.logout = () => {
  return (dispatch) => {
    cookieHandle.remove('token');
    cookieHandle.remove('gbAuthorization');
    cookieHandle.remove('gbPersonId');
    // cookieHandle.remove("beautyProfileModal");
    // cookieHandle.remove("mgmCookieModal");
    // cookieHandle.remove("gpCookieModal");

    if (localStorage) {
      let localStore = new GlamboxLocalStore();
      localStore.remove('GlamboxCurrentUser');
      localStore.remove('PersonGeral');
    }

    dispatch(TokenActions.unset());

    dispatch(PersonActions.unset());
    dispatch(NotifsActions.unset());
    dispatch(RewardsActions.unset());
    dispatch(BeautyProfileActions.unset());
    dispatch(EditionsActions.unset());
    dispatch(SubscribersActions.unset());

    dispatch(PartnerInfoActions.unset());
    dispatch(PartnerGeneralActions.unset());
    dispatch(PartnerSalesActions.unset());
  };
};

TokenActions.fetch = (
  endpoint,
  data,
  method,
  clearInfos = false,
  isLogin = false,
  isRegistration = false
) => {
  return (dispatch) => {
    let requestData = Object.assign({}, data);

    dispatch(UiActions.loaderShow());

    dispatch(TokenActions.start());

    let queueId = 'UserToken-' + Date.now();
    dispatch(UiActions.queue(queueId));

    let bulkLoadId = 'BulkLoadData-' + Date.now();
    dispatch(UiActions.queue(bulkLoadId));

    ExecuteRequest(
      endpoint,
      requestData,
      method,
      null,
      null,

      (response, error) => {
        let { result, resultType, message } = response;

        dispatch(UiActions.loaderHide());

        dispatch(TokenActions.pending(false));

        if (!error) {
          if (clearInfos === true) {
            dispatch(TokenActions.logout());
          }

          if (isLogin) {
            storageHandle.set('userJustRegistered', false);
            storageHandle.set('userCheckFlag', true);
          }

          if (isRegistration) {
            storageHandle.set('userJustRegistered', true);
            storageHandle.set('userCheckFlag', true);
          }

          dispatch(TokenActions.success(true));

          dispatch(TokenActions.set(result));

          storageHandle.set('GlamboxCurrentUser', result);

          let { access_token, personId, userEmail } = result;

          if (access_token !== undefined) cookieHandle.set('token', access_token);

          // if (document && window && window.location && !data.hasOwnProperty("access_token")) {
          //   let referrer = document.referrer,
          //       hostname = window.location.hostname,
          //       hnamergx = new RegExp(referrer, "gi");

          //   if (hnamergx.test(hostname) === false) {
          //     window.location = document.referrer;
          //   }
          // }

          dispatch(TokenActions.loadBulkData(access_token, personId, userEmail, bulkLoadId));
        } else {
          dispatch(UiActions.dequeue(bulkLoadId));

          dispatch(UiActions.publishErrorAlert(error.message));
        }

        dispatch(UiActions.dequeue(queueId));
      }
    );
  };
};

TokenActions.start = () => {
  return (dispatch) => {
    dispatch(TokenActions.pending(true));
    dispatch(TokenActions.success(false));
    dispatch(TokenActions.error(null));
  };
};

TokenActions.loadBulkData = (email, bulkLoadId) => {
  return (dispatch) => {
    // PERSON INFO
    let a = () => {
      dispatch(PersonActions.fetch());
    };

    // NOTIFICATIONS
    let b = () => {
      dispatch(NotifsActions.fetch(0, 4));
    };

    a();
    b();

    // REWARDS
    let c = () => {
      dispatch(RewardsActions.fetch());
    };

    c();

    // BEAUTY PROFILE
    dispatch(BeautyProfileActions.fetch());

    // PERSON IS INFLUENCER?
    dispatch(PersonActions.isInfluencer());

    // EDITIONS LOADER
    dispatch(EditionsActions.fetch());

    // DEQUEUE
    dispatch(UiActions.dequeue(bulkLoadId));

    // PARTNER INFO
    //dispatch(PartnerInfoActions.fetch());

    // PARTNER GENERAL
    //dispatch(PartnerGeneralActions.fetch());

    // PARTNER SALES
    //dispatch(PartnerSalesActions.fetch());
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

TokenActions.sync = () => ({
  person: {
    lastSync: Date.now(),
  },
  type: PersonTypes.sync,
});

TokenActions.set = (token) => ({
  token: {
    data: token,
    lastSync: Date.now(),
  },
  type: TokenTypes.set,
});

TokenActions.unset = () => ({
  token: InitialState.createSyncObject(),
  type: TokenTypes.unset,
});

TokenActions.success = (success) => ({
  token: {
    success: success === true,
  },
  type: TokenTypes.success,
});

TokenActions.pending = (pending) => ({
  token: {
    pending: pending === true,
  },
  type: TokenTypes.pending,
});

TokenActions.error = (error) => ({
  token: {
    error,
  },
  type: TokenTypes.error,
});
